import { useState, useEffect } from "react";
import api from "../services/api";

export default function ProfileModal({ show, onClose, user, onUpdate }) {
  const [tab, setTab] = useState("profile"); // profile | password
  const [form, setForm] = useState({ full_name: "", email: "", phone: "" });
  const [pwForm, setPwForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null); // { type: 'success'|'error', text }

  useEffect(() => {
    if (show && user) {
      setForm({ full_name: user.full_name || "", email: user.email || "", phone: user.phone || "" });
      setPwForm({ current_password: "", new_password: "", confirm_password: "" });
      setMessage(null);
      setTab("profile");
    }
  }, [show]); // sadece modal açılınca sıfırla, user değişince değil

  const handleSaveProfile = async () => {
    if (!form.full_name.trim() || !form.email.trim()) {
      setMessage({ type: "error", text: "Ad soyad ve email zorunlu" });
      return;
    }
    setSaving(true); setMessage(null);
    try {
      const res = await api.patch("/auth/me", form);
      // Yeni token ve kullanıcı bilgisini kaydet
      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem("user", JSON.stringify({ ...user, ...res.data.data.user }));
      setMessage({ type: "success", text: "Profil güncellendi" });
      if (onUpdate) onUpdate(res.data.data.user);
    } catch (e) {
      setMessage({ type: "error", text: e.response?.data?.message || "Hata oluştu" });
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = async () => {
    if (!pwForm.current_password || !pwForm.new_password || !pwForm.confirm_password) {
      setMessage({ type: "error", text: "Tüm alanları doldurun" });
      return;
    }
    if (pwForm.new_password !== pwForm.confirm_password) {
      setMessage({ type: "error", text: "Yeni şifreler eşleşmiyor" });
      return;
    }
    if (pwForm.new_password.length < 8) {
      setMessage({ type: "error", text: "Yeni şifre en az 8 karakter olmalı" });
      return;
    }
    setSaving(true); setMessage(null);
    try {
      await api.patch("/auth/change-password", {
        current_password: pwForm.current_password,
        new_password: pwForm.new_password
      });
      setMessage({ type: "success", text: "Şifre başarıyla değiştirildi" });
      setPwForm({ current_password: "", new_password: "", confirm_password: "" });
    } catch (e) {
      setMessage({ type: "error", text: e.response?.data?.message || "Hata oluştu" });
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-bold">👤 Profil Ayarları</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-2xl leading-none font-bold">×</button>
        </div>

        {/* Tabs */}
        <div className="flex border-b">
          <button
            onClick={() => { setTab("profile"); setMessage(null); }}
            className={`flex-1 py-3 text-sm font-semibold ${tab === "profile" ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-500 hover:text-gray-700"}`}
          >
            Profil Bilgileri
          </button>
          <button
            onClick={() => { setTab("password"); setMessage(null); }}
            className={`flex-1 py-3 text-sm font-semibold ${tab === "password" ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-500 hover:text-gray-700"}`}
          >
            Şifre Değiştir
          </button>
        </div>

        <div className="px-6 py-5">
          {/* Mesaj */}
          {message && (
            <div className={`mb-4 px-4 py-3 rounded-lg text-sm ${message.type === "success" ? "bg-green-50 border border-green-200 text-green-700" : "bg-red-50 border border-red-200 text-red-700"}`}>
              {message.type === "success" ? "✅ " : "❌ "}{message.text}
            </div>
          )}

          {/* PROFİL FORMU */}
          {tab === "profile" && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Ad Soyad</label>
                <input
                  type="text"
                  value={form.full_name}
                  onChange={e => setForm({ ...form, full_name: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">E-posta</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Telefon <span className="text-gray-400 font-normal">(opsiyonel)</span></label>
                <input
                  type="tel"
                  value={form.phone}
                  onChange={e => setForm({ ...form, phone: e.target.value })}
                  placeholder="05xx xxx xx xx"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="flex gap-3 justify-end pt-1">
                <button onClick={onClose} className="px-4 py-2 border rounded-lg text-sm text-gray-600 hover:bg-gray-50">İptal</button>
                <button
                  onClick={handleSaveProfile}
                  disabled={saving}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-lg text-sm font-semibold"
                >
                  {saving ? "Kaydediliyor..." : "Kaydet"}
                </button>
              </div>
            </div>
          )}

          {/* ŞİFRE FORMU */}
          {tab === "password" && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Mevcut Şifre</label>
                <input
                  type="password"
                  value={pwForm.current_password}
                  onChange={e => setPwForm({ ...pwForm, current_password: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="••••••••"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Yeni Şifre</label>
                <input
                  type="password"
                  value={pwForm.new_password}
                  onChange={e => setPwForm({ ...pwForm, new_password: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="En az 8 karakter"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Yeni Şifre Tekrar</label>
                <input
                  type="password"
                  value={pwForm.confirm_password}
                  onChange={e => setPwForm({ ...pwForm, confirm_password: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="••••••••"
                />
                {pwForm.new_password && pwForm.confirm_password && pwForm.new_password !== pwForm.confirm_password && (
                  <p className="text-xs text-red-500 mt-1">Şifreler eşleşmiyor</p>
                )}
              </div>
              <div className="flex gap-3 justify-end pt-1">
                <button onClick={onClose} className="px-4 py-2 border rounded-lg text-sm text-gray-600 hover:bg-gray-50">İptal</button>
                <button
                  onClick={handleChangePassword}
                  disabled={saving}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-lg text-sm font-semibold"
                >
                  {saving ? "Değiştiriliyor..." : "Şifreyi Değiştir"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}